export default __webpack_public_path__ + "static/media/travel-bag-2x.54d6612f.webp";